// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2d-q";
export var animationRelative = "_2d-p";
export var backdropBlur = "_2d-0";
export var detailLabelCell = "_2d-12";
export var detailTable = "_2d-11";
export var detailValueCell = "_2d-13";
export var docIconBox = "_2d-1d";
export var docIconBoxMd = "_2d-1f";
export var docIconBoxSm = "_2d-1e";
export var docTypeRow = "_2d-16";
export var docTypeRowInner = "_2d-17";
export var dropdownMatchDatePicker = "_2d-3";
export var evidenceCardContent = "_2d-1c";
export var fileUploadSpin = "_2d-j";
export var gorgiasOpenButton = "_2d-15 _2d-d";
export var gorgiasTicketCard = "_2d-14";
export var heroModalFooterButton = "_2d-18";
export var hiddenContainer = "_2d-o";
export var iconPrimary = "_2d-1g";
export var iconSecondary = "_2d-1h";
export var iconTertiary = "_2d-1i";
export var integrationCard = "_2d-1";
export var integrationLogoBox = "_2d-2";
export var mainColumnSticky = "_2d-1b";
export var maxWidthContainer = "_2d-19";
export var modalContentBody = "_2d-a";
export var modalHeaderImage = "_2d-5";
export var modalImageLabel = "_2d-7";
export var modalImageOverlay = "_2d-6";
export var modalImageSubtitle = "_2d-9";
export var modalImageTitle = "_2d-8";
export var modalImageWrapper = "_2d-4";
export var modalStickyFooter = "_2d-b";
export var removeButton = "_2d-e";
export var sidebarColumn = "_2d-1a";
export var spinner = "_2d-i";
export var timelineLine = "_2d-y";
export var timelineLineBlack = "_2d-10 _2d-y";
export var timelineLineGray = "_2d-z _2d-y";
export var timelineLineHeight = "_2d-x";
export var tlDotActivate = "_2d-u";
export var tlDotActivateAnim = "_2d-t";
export var tlDotHide = "_2d-s";
export var tlDotHideAnim = "_2d-r";
export var tlLineActivate = "_2d-w";
export var tlLineActivateAnim = "_2d-v";
export var uploadHint = "_2d-n";
export var uploadIconBox = "_2d-k";
export var uploadLabel = "_2d-m";
export var uploadText = "_2d-l";
export var uploadZone = "_2d-f";
export var uploadZoneCursorDefault = "_2d-h";
export var uploadZoneCursorPointer = "_2d-g";
export var uploadedFileRow = "_2d-c";
export var viewButton = "_2d-d";